const Cancel = function () {
  this.editUser.resetEditUserModal()
}

export default Cancel
